function loadAndParseCSV() {
        $.ajax({
            url: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQR6S9_VWIkG46SegdibP-QwWRDzwgxw7NjD_XqIPkXh9qdzHQQL1H1dkLBTqu31jB9XuRsQV9mW4rT/pub?gid=0&single=true&output=csv',
            dataType: 'text',
            success: function(data) {
                var lines = data.split("\n");
                var headers = lines[0].split(",");
                var allData = [];
                for (var i = 1; i < lines.length; i++) {
                    var cells = lines[i].split(",");
                    var rowObject = {};
                    headers.forEach((header, index) => {
                        rowObject[header] = cells[index];
                    });
                    allData.push(rowObject);
                }
                sessionStorage.setItem('csvDataDelivery', JSON.stringify(allData));
            }
        });
    }
    if (!sessionStorage.getItem('csvDataDelivery')) {
        loadAndParseCSV();
    }    